import apiClient from '../axios.js';

/**
 * 取貨預約管理 API
 */
export const pickupAppointmentService = {
  /**
   * 查詢取貨預約列表
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 取貨預約列表
   */
  getPickupAppointments: async (params = {}) => {
    const response = await apiClient.get('/pickup-appointments', { params });
    return response;
  },

  /**
   * 查詢取貨預約詳情
   * @param {string} id - 預約 ID
   * @returns {Promise<Object>} 取貨預約詳情
   */
  getPickupAppointment: async (id) => {
    const response = await apiClient.get(`/pickup-appointments/${id}`);
    return response;
  },

  /**
   * 查詢可選時段
   * @param {string} storeId - 門市 ID
   * @param {string} date - 日期
   * @returns {Promise<Object>} 可選時段
   */
  getAvailableSlots: async (storeId, date) => {
    const response = await apiClient.get('/pickup-appointments/available-slots', {
      params: { storeId, date }
    });
    return response;
  },

  /**
   * 建立取貨預約
   * @param {Object} appointmentData - 預約資料
   * @returns {Promise<Object>} 建立結果
   */
  createPickupAppointment: async (appointmentData) => {
    const response = await apiClient.post('/pickup-appointments', appointmentData);
    return response;
  },

  /**
   * 更新取貨預約
   * @param {string} id - 預約 ID
   * @param {Object} appointmentData - 預約資料
   * @returns {Promise<Object>} 更新結果
   */
  updatePickupAppointment: async (id, appointmentData) => {
    const response = await apiClient.put(`/pickup-appointments/${id}`, appointmentData);
    return response;
  },

  /**
   * 取消取貨預約
   * @param {string} id - 預約 ID
   * @returns {Promise<Object>} 取消結果
   */
  cancelPickupAppointment: async (id) => {
    const response = await apiClient.delete(`/pickup-appointments/${id}`);
    return response;
  },

  /**
   * 確認取貨
   * @param {string} id - 預約 ID
   * @param {Object} pickupData - 取貨資料
   * @returns {Promise<Object>} 確認結果
   */
  confirmPickup: async (id, pickupData) => {
    const response = await apiClient.post(`/pickup-appointments/${id}/pickup`, pickupData);
    return response;
  }
};
